/* Imports */
import React from "react"
import { Link } from "react-router-dom"
import { Font, Button } from "fajny-react"

import PageLayout from "../components/PageLayout"

const NotFound = ({ icon }) => {
    return (
        <PageLayout title="404">
            {icon && (
                <Button
                    to="/icons"
                    fajnyIconLeft="arrow-left-solid"
                    buttonStyle="text"
                    noPadding
                >
                    Back to the list
                </Button>
            )}

            <Font.H1>404 not found!</Font.H1>

            {icon ? (
                <Font.P>
                    This icon does not exist!{" "}
                    <Link to="/icons">Back to the list</Link>.
                </Font.P>
            ) : (
                <Font.P>
                    The page you're looking for does not exist.{" "}
                    <Link to="/">Back to homepage.</Link>
                </Font.P>
            )}
        </PageLayout>
    )
}

export default NotFound
